"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const openapi_1 = require("../../openapi");
const OperationErrorCode_1 = __importDefault(require("./OperationErrorCode"));
let OperationError = class OperationError extends Error {
    errorCode;
    paramName;
    constructor(errorCode, name) {
        let message;
        switch (errorCode) {
            case OperationErrorCode_1.default.Duplicate:
                message = `${name} already exists`;
                break;
            case OperationErrorCode_1.default.DoesNotExist:
                message = `${name} does not exist`;
                break;
            case OperationErrorCode_1.default.Required:
                message = `${name} is required`;
                break;
            case OperationErrorCode_1.default.NotParsable:
                message = `${name} is not parsable`;
                break;
            case OperationErrorCode_1.default.Incompatible:
                message = `${name} is incompatible`;
                break;
            case OperationErrorCode_1.default.InvalidValue:
                message = `${name} is invalid`;
                break;
            case OperationErrorCode_1.default.Disallowed:
                message = `${name} is not allowed`;
                break;
            case OperationErrorCode_1.default.InvalidApiResponse:
                message = `${name} api returned invalid response`;
                break;
            default:
                message = `Invalid operation. Unknown Error Code`;
        }
        super(message);
        this.errorCode = errorCode;
        this.paramName = name;
    }
};
__decorate([
    (0, openapi_1.Schema)({
        type: 'number',
        description: 'The number of the OperationErrorCode',
    })
], OperationError.prototype, "errorCode", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'string',
        description: 'The name of the parameter that triggered the error throw',
    })
], OperationError.prototype, "paramName", void 0);
OperationError = __decorate([
    (0, openapi_1.ClassSchema)({
        description: 'Error thrown when an invalid operation is performed',
    })
], OperationError);
exports.default = OperationError;
